import { cx } from 'src/utils/cx'
import TwemojiMoneyBag from '~icons/twemoji/money-bag'
import { UILink } from '../ui/Link'
import Text from '../ui/Text'

export function GeneratorEntry(props: StyleProps) {
  return (
    <UILink
      className={cx(props.className, 'rounded-2xl', 'pr-4')}
      href="/user-referral"
      icon={<TwemojiMoneyBag className="size-4" />}
      variant="outlined"
    >
      <Text
        i18nKey={[
          'growth:generation.referral-entry.label',
          'user:referral.menu-label',
        ]}
      />
    </UILink>
  )
}
